export const TOAST_TIMEOUT = 5000;

export const TOAST_LIMIT = 20;

export const MILLISECONDS_MULTIPLIER = 1000;

export const DURATION_PADDING = 5;
